<template>
<div class="PurchaseNote">
    <div class="page-title">결제어음 관리</div>
    <ATable
        ref="table"
        v-loading="loading"
        placeholder="어음번호,거래처"
        buttons-width="300px"
        :search_field="search_field"
        :data="tableDataNote"
        hide-button-insert
        @row-click="handleClickRow"
        @selection-change="noteSelectionChange"
    >
        <el-table-column type="selection" label="선택" align="center" :width="$width.selection" />
        <el-table-column type="index" label="No" :index="handleIndex" :width="$width.index" />
        <el-table-column prop="number" label="어음번호" />
        <el-table-column prop="issue_date"  label="발행일자" />
        <el-table-column prop="expire_date" label="만기일자" />
        <el-table-column prop="price" label="발행금액" :formatter="util.numberFormat" class-name="cell-number" />
        <el-table-column prop="customer_name" label="거래처"/>
        <el-table-column prop="customer_charger" label="담당자" />
        <el-table-column prop="customer_tel" label="연락처" />
        <el-table-column prop="status_flag" label="상태" >
            <template slot-scope="scope">
                {{ resolveStatus(scope.row.status_flag , scope.row.expire_date) }}
            </template>
        </el-table-column>
        <el-table-column prop="desc" label="기록사항"  show-overflow-tooltip />
        <div slot="buttons">
            <div class="inline" style="margin-right: 10px">
                <el-button
                    type="primary"
                    @click="doCreate"
                >어음등록(F2)</el-button>
            </div>
            <div class="inline" style="margin-right: 10px">
            <el-button
                type="primary"
                :disabled="!(noteSelection.length > 0)"
                @click="StatusToRegister"
            >결제등록</el-button
            >
            </div>
            <div class="inline" style="margin-right: 10px">
                <el-button
                    type="danger"
                    :disabled="!(noteSelection.length > 0)"
                    @click="StatusToCancel"
                >결제취소</el-button>
            </div>
        </div>
    </ATable>
    <div class="flex row-splitter">
        <el-dialog
            title="결제어음"
            top="0"
            custom-class="form-dialog"
            destroyOnClose
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            :before-close="beforeClose"
            @opened="handleOpened"
        >
            <NoteForm
                ref="form"
                flag="P"
                :data="form_data"
                @completed="handleCompleted"
            ></NoteForm>
        </el-dialog> 
    </div>
</div>
</template>

<script>
import { form_container } from "@/common/mixins/form_container";
import NoteForm from './NoteForm';

export default {
    name: "PurchaseNote",
    mixins: [form_container],
    components: {NoteForm},
    data() {
        return {
            loading: false,
            items_note: [],
            search_field: ["number", "customer_name"],
            period: {},
            noteSelection: [],
            searchWord: null,
            fixedSearchWord: "",
            pageSize: 10,
            form_data: [],
            statusFlag: true,
            dialogVisible: false
        };
    },
    computed: {
        filterDataNote: function() {
            let items = this.items_note.filter(item => {
                return !item.hidden;
            });
            items = this.util.filterMultiFields(
                items,
                this.search_field,
                this.fixedSearchWord
            );
            items = items.sort(this.compareNote());
            return items;
        },
        recordCountNote() {
            return this.filterDataNote.length;
        },
        tableDataNote() {
            return this.filterDataNote
        },
    },
    mounted() {
        this.$nextTick(() => this.loadData());
    },
    methods: { 
        handleClickRow(data) {
            this.openDialog(data);
        },
        openDialog(data) {
            let clone = data ? Object.assign({}, data) : undefined;
            this.form_data = clone;
            this.dialogVisible = true;
        },
        loadData() {
            this.loading = true;
            this.api.listPurchaseNote().then(res => {
                this.loading = false;
                if (res.error !== this.system.noError) {
                    this.util.notify_error(this, "note", res.message);
                    return;
                }
                this.items_note = res.data;
            });
        },
        resolveStatus(value,expire_date) {
            let ret = "";
            switch (value) {
            case "0":
                if(this.util.getDateString(expire_date) <= this.util.getDateString(this.util.getDate(7)))
                    ret = '만기';
                else
                    ret = '진행';
                break;
            case "1":
                ret = '입금완료';
                break;
            }
            return ret;
        },
        compareNote() {
            return function(a, b) {
                if (a.number < b.number) {
                    return -1;
                } else if (a.number === b.number) {
                    return a.seq - b.seq;
                } else {
                    return 1;
                }
            };
        },
        handleIndex(index) {
            return this.$refs.table.indexResolver(index);
        },
        handleClickFilter() {
            this.fixedSearchWord = this.searchWord;
        },
        noteSelectionChange(selection) {
            this.statusFlag = false;
            this.noteSelection = selection;
        },
        handleCompleted(message) {
            this.dialogVisible = false;
            this.form_data = undefined;
            if (!message) { return; }
            this.$notify(message);
            this.loadData()
        },
        StatusToRegister() {
            let params = [];
            this.noteSelection.forEach(item => {
                item.status_flag="1"
                params.push(item.id)
            });
            this.api.updateRegisterNote(params).then(res => {
                if (res.error !== this.system.noError) {
                    this.util.notify_error(this, "어음", res.message);
                    return;
                }
                this.loadData();
            });
        },
        StatusToCancel() {
            let params=[];
            this.noteSelection.forEach(item => {
                item.status_flag="0"
                params.push(item.id)
            });
            this.api.updateCancelNote(params).then(res => {
                if (res.error !== this.system.noError) {
                    this.util.notify_error(this, "어음", res.message );
                    return;
                }
                this.loadData();
            });
        },
        doCreate() {
            this.form_data=undefined //추가생성시 초기화
            this.openDialog();
        }
    }
};
</script>
